import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CardLayoutComponent } from '../shared/card-layout/card-layout.component';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-valuables',
    imports: [CardLayoutComponent],
    template: `
        <app-card-layout
            (click)="isActive = !isActive"
            [isActive]="isActive"
            title="Valuables"
            icon="valuables"
            subtitle="Valuables"
            [isLoading]="isDCPolicyLoaded"
            [failed]="dcPolicyFailed"
            [columns]="['VALUABLES NAME', 'LIMIT', 'PREMIUM']"
            [fields]="fields"
            (retry)="retryDCPolicy()"
        ></app-card-layout>
    `,
})
export class ValuablesComponent {
    isActive = false;
    @Input() isDCPolicyLoaded = false;
    @Input() dcPolicyFailed = false;
    @Output() retry = new EventEmitter<void>();
    private store = inject(Store);
    policySignal = this.store.selectSignal((state: any) => state.policy);

    private formatCurrency(value: any): string {
        const num = Number(value);
        const safe = isNaN(num) ? 0 : num;
        const abs = Math.abs(safe).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return safe < 0 ? `-$${abs}` : `$${abs}`;
    }

    get fields() {
        const policyState = this.policySignal();
        const policyNum = policyState.policyNumber;
        const data = policyState.data?.[policyNum]?.policySnapshot?.valuables;
        if (!data) return [];
        return Object.values(data).map((v: any) => ({
            caption: v.node,
            value: v.value,
            premium: this.formatCurrency(v.premium ?? 0),
        }));
    }

    retryDCPolicy() {
        this.retry.emit();
    }
}
